import Layout from "@/modules/projects/project-layout"
import MyProjects from "@/modules/projects/component/MyProjects"
import SchoolProjects from "@/modules/projects/component/SchoolProjects"
import FillLayout from "@/modules/documents/fill-layout"

const ProjectRouter = {
	path: "/projects",
	name: "projects",
	component: Layout,
	children: [
		//COMMONS
		{
			//visualizzazione dentro progetto
			path: "my-projects/:project_id",
			name: "projects.my-projects.project_id",
			component: MyProjects,
			props: true
		},
		{
			//fill di un document dentro progetto
			path: "my-projects/:project_id/fill/:documentId",
			name: "projects.my-projects.project_id.fill.documentId",
			component: FillLayout,
			props: true
		},
		{
			//sembra inutile ma serve per breadcrumb, non spostare
			path: "my-projects/:project_id/fill",
			name: "projects.my-projects.project_id",
			component: MyProjects,
			props: true
		},
		{
			//fill di un document dentro progetto > procedura
			path: "my-projects/:project_id/:folder_id/fill/:documentId",
			name: "projects.my-projects.project_id.folder_id.fill.documentId",
			component: FillLayout,
			props: true
		},
		{
			//sembra inutile ma serve per breadcrumb, non spostare
			path: "my-projects/:project_id/:folder_id/fill",
			name: "projects.my-projects.project_id.folder_id",
			component: MyProjects,
			props: true
		},
		{
			//visualizzazione dentro progetto > procedura
			path: "my-projects/:project_id/:folder_id",
			name: "projects.my-projects.project_id.folder_id",
			component: MyProjects,
			props: true
		},
		{
			//visualizzazione progetti
			path: "my-projects",
			name: "projects.my-projects",
			component: MyProjects,
			props: true
		},

		//ADMIN
		{
			//selezione scuola per visualizzare i progetti
			path: "",
			name: "projects.school-projects",
			component: SchoolProjects,
			props: true
		},
		{
			//selezione scuola per visualizzare i progetti
			path: "school-projects",
			name: "projects.school-projects",
			component: SchoolProjects,
			props: true
		},
		{
			//tutti i progetti della scuola
			path: "school-projects/:school_id",
			name: "projects.school-projects.school_id",
			component: MyProjects,
			props: true
		},
		{
			//visualizzazione dentro progetto
			path: "school-projects/:school_id/:project_id",
			name: "projects.school-projects.school_id.project_id",
			component: MyProjects,
			props: true
		},
		{
			//fill di un document dentro progetto
			path: "school-projects/:school_id/:project_id/fill/:documentId",
			name: "projects.school-projects.school_id.project_id.fill.documentId",
			component: FillLayout,
			props: true
		},
		{
			//sembra inutile ma serve per breadcrumb, non spostare
			path: "school-projects/:school_id/:project_id/fill",
			name: "projects.school-projects.school_id.project_id",
			component: MyProjects,
			props: true
		},
		{
			//fill di un document dentro progetto > procedura
			path: "school-projects/:school_id/:project_id/:folder_id/fill/:documentId",
			name: "projects.school-projects.school_id.project_id.folder_id.fill.documentId",
			component: FillLayout,
			props: true
		},
		{
			//sembra inutile ma serve per breadcrumb, non spostare
			path: "school-projects/:school_id/:project_id/:folder_id/fill",
			name: "projects.school-projects.school_id.project_id.folder_id",
			component: MyProjects,
			props: true
		},
		{
			//visualizzazione dentro progetto > procedura
			path: "school-projects/:school_id/:project_id/:folder_id",
			name: "projects.school-projects.school_id.project_id.folder_id",
			component: MyProjects,
			props: true
		}
	]
}

export default ProjectRouter
